import helper from '../helper'

export default {
  controller: '/users',
  all (callback) {
    helper.getRequest(this.controller, true, callback)
  },
  add (user, callback) {
    helper.postRequest(this.controller, true, user, callback)
  },
  update (user, callback) {
    helper.putRequest(this.controller + '/' + user.id, true, user, callback)
  },
  delete (id, callback) {
    helper.deleteRequest(this.controller + '/' + id, true, callback)
  }
}



// WEBPACK FOOTER //
// ./src/services/rest/controllers/users.js